import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getTournament = async (tournamentId) => {
    const useLegacyEndpoint = process.env.REPEAT_USE_LEGACY_TOURNAMENT_ENDPOINT === 'true';
    const requestUrl = useLegacyEndpoint
        ? `${SYMFONY_API_BASE_URL}/api/tournament/v1`
        : `${process.env.REPEAT_TOURNAMENT_SERVICE_URL}/tournament/public/api/tournaments/${tournamentId}`;
    const response = await axios.get(requestUrl, {
        ...(useLegacyEndpoint && { params: { id: tournamentId } }),
    });
    return response;
};
export default getTournament;
